import { partfinitiClient } from 'core/services';
import { IUserSetting } from 'user/types';

export const upsertUserSetting = async (data: { userSetting: IUserSetting }) =>
  partfinitiClient.postForm('/user/my-setting-edit/save', data);
